<template>
   <section class='main-content'>
        <h1> Tens certeza? </h1>
   </section>
</template>
  
<script>
 
   export default { 
 
       components: {   
       }, 
       data(){
           return{ 
           } 
       }, 
       methods: {  
       }, 
       created(){
       } 

   }
</script>
 
<style scoped>
   .main-content{ 
        margin: 0 auto;
        height: 10em;
        background-color: red;
   
   } 
</style> 